import { Component, Vue } from 'vue-property-decorator';

interface BreadcrumbLink {
  name?: string;
  path?: string;
}

interface Breadcrumb {
  text: string;
  to: BreadcrumbLink;
}

type Breadcrumbs = Array<Breadcrumb>;

@Component
export default class BreadcrumbMixin extends Vue {
  breadcrumbs: Breadcrumbs = [{
    text: 'Главная',
    to: { path: '/' },
  }];
}



// WEBPACK FOOTER //
// ./src/mixins/breadcrumbs.ts